<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.apptype.entrance']">
              <!--              <a-input :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"  v-model="queryParam.entranceId"></a-input>-->
              <a-select
                allowClear
                :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"
                v-model="queryParam.entranceId"
              >
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['application.applicationName']">
              <j-input :placeholder="language['basedata.pleaseEnter']" v-model="queryParam.applicationName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['application.applicationCode']">
              <j-input :placeholder="language['basedata.pleaseEnter']" v-model="queryParam.applicationCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['application.applicationStatus']">
              <j-dict-select-tag  v-model="queryParam.applicationStatus"  :type="'radio'" dictCode="application_status"/>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" v-has="'empapp:insert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('sys_bm_application')">导出</a-button>-->
      <!--<a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"
                @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal"
                     @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" v-has="'empapp:batchDel'"  @click="batchDel">
            <a-icon type="delete"/>
            {{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt=""
               style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'empapp:edit'" >{{language['common.edit']}}</a>

          <a-divider type="vertical" v-has="'empapp:edit'"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'empapp:detail'">
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'empapp:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <template slot="applicationImgPath" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.applicationImgPath)" icon="user"/>
          </div>
        </template>
        <template slot="applicationDesc" slot-scope="text, record, index">
          <a-tooltip :title="record.applicationDesc" placement="topLeft" :disabled="false">
             <span>{{!text?"":(text.length>25?text.substr(0,25)+"...":text)}}</span>
          </a-tooltip>
        </template>
        <template slot="entranceAppTypeInfo" slot-scope="text, record, index">
          <a-tooltip :title="record.entranceAppTypeInfo" placement="topLeft" :disabled="false">
             <span>{{!text?"":(text.length>50?text.substr(0,50)+"...":text)}}</span>
          </a-tooltip>
        </template>
        <template slot="applicationUrl" slot-scope="text, record, index">
          <a-tooltip :title="record.applicationUrl" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>50?text.substr(0,50)+"...":text)}}</span>
          </a-tooltip>
        </template>
        <template slot="h5Url" slot-scope="text, record, index">
          <a-tooltip :title="record.h5Url" placement="topLeft" :disabled="false">
              <span>{{!text?"":(text.length>50?text.substr(0,50)+"...":text)}}</span>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <sys-bm-application-modal ref="modalForm" @ok="modalFormOk"></sys-bm-application-modal>
  </a-card>


</template>

<script>

  import '@/assets/less/TableExpand.less'
  import {mixinDevice} from '@/utils/mixin'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysBmApplicationModal from './modules/SysBmApplicationModal'
  import {putAction,getFileAccessHttpUrl,httpAction} from '@/api/manage';

  export default {
    name: 'SysBmApplicationList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      SysBmApplicationModal
    },
    data() {
      return {
        // 表头
        uploadSource:"platform",
        url: {
          list: "/sys/sysBmApplication/listForEmp",
          delete: "/sys/sysBmApplication/delete",
          deleteBatch: "/sys/sysBmApplication/deleteBatch",
          exportXlsUrl: "/sys/sysBmApplication/exportXls",
          importExcelUrl: "sys/sysBmApplication/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        entrances:[{
          id:'',
          colName:'',
          entranceName:''
        }],
      }
    },
    created() {
      // this.getSuperFieldList();
      this.getEntranceList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: "center",
              fixed: 'left',
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: this.language['application.applicationName'],
              align: "center",
              fixed: 'left',
              width: 150,
              dataIndex: 'applicationName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:  this.language['application.applicationCode'],
              align: "center",
              width: 150,
              dataIndex: 'applicationCode',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['application.applicationStatus'],
              align: "center",
              width: 100,
              dataIndex: 'applicationStatusDictText'
            },
            {
              title: this.language['application.applicationType'],
              align: "center",
              width: 100,
              dataIndex: 'applicationTypeDictText'
            },
            {
              title: this.language['application.applicationDesc'],
              align: "center",
              width: 150,
              ellipsis: true,
              dataIndex: 'applicationDesc',
              scopedSlots: {customRender: "applicationDesc"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['emp.apptype.entrance']+':'+this.language['emp.develop.appType'],
              align: "center",
              width: 200,
              ellipsis: true,
              dataIndex: 'entranceAppTypeInfo',
              scopedSlots: {customRender: "entranceAppTypeInfo"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['application.thirdFlag'],
              align: "center",
              width: 60,
              dataIndex: 'thirdFlag_dictText'
            },
            {
              title: this.language['application.ssoFlag'],
              align: "center",
              width: 100,
              dataIndex: 'ssoFlag_dictText'
            },
            {
              title: this.language['application.applicationImgPath'],
              align: "center",
              dataIndex: 'applicationImgPath',
              width: 100,
              scopedSlots: {customRender: "applicationImgPath"}
            },
            {
              title: this.language['application.applicationUrl'],
              align: "center",
              width: 200,
              ellipsis: true,
              dataIndex: 'applicationUrl',
              scopedSlots: {customRender: "applicationUrl"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['application.h5Url'],
              align: "center",
              ellipsis: true,
              dataIndex: 'h5Url',
              scopedSlots: {customRender: "h5Url"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align: "center",
              fixed: "right",
              width: 147,
              scopedSlots:{
                customRender: 'action'
              }
            }
          ]
        }
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },
      initDictConfig() {
      },
      getSuperFieldList() {
        let fieldList = [];
        fieldList.push({type: 'string', value: 'applicationName', text: '应用名称11'})
        fieldList.push({type: 'string', value: 'applicationDesc', text: '应用描述'})
        fieldList.push({type: 'string', value: 'applicationCode', text: '应用编码'})
        fieldList.push({type: 'string', value: 'applicationStatus', text: '应用状态'})
        fieldList.push({type: 'string', value: 'applicationType', text: '应用类型:platform-平台，application-应用'})
        fieldList.push({type: 'string', value: 'remark', text: '备注'})
        fieldList.push({type: 'string', value: 'activeFlag', text: '是否有效'})
        fieldList.push({type: 'string', value: 'isDeleted', text: '是否删除'})
        this.superFieldList = fieldList
      },
      getEntranceList(){
        httpAction("/hhemp/entrance/empcmsentrances2?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>